import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../uicomponentcss';
import { Colors } from '../../../../utils/resources/colors';

export interface PaginationCardCSSStyle extends UIComponentCSSStyle
{
    getInnerWrapperCSSStyle(onSelectNext:boolean):object;
    getPaginationIndexCSSStyle(onSelectNext:boolean):object;

}

export class PaginationCardCSSStyleImpl extends UIComponentCSSStyleImpl implements PaginationCardCSSStyle
{
    getWrapperCSSStyle():object
    {
        return{
            width:'40px',
            height:'40px',
            // marginLeft: "10px",
            // margingRight: "10px",
            cursor: "pointer",
            border:' 1px solid'+this.getResources().getColor(Colors.color_3),
            backgroundColor: this.getResources().getColor(Colors.color_17),
            // boxShadow: '0 2px 10px 0px'+this.getResources().getColor(Colors.color_4)
        };
    }

    getInnerWrapperCSSStyle(onSelectNext:boolean):object
    {
        return{
            width:"100%",
            height:'100%',
            cursor: "pointer",
            border:' 1px solid'+this.getResources().getColor(Colors.color_3),
            backgroundColor:onSelectNext?this.getResources().getColor(Colors.color_17): this.getResources().getColor(Colors.color_5),
            // boxShadow: '0 2px 10px 0px rgba(0,0,0,0.07)',
            boxSizing: "border-box"
        };
       
    }
    getPaginationIndexCSSStyle(onSelectNext:boolean):object
    {
        return{
            height: '17px',
            margin:'11px 9px 11px 13px',
            width: '9px',
            cursor: "pointer",
            color:onSelectNext? this.getResources().getColor(Colors.color_6):this.getResources().getColor(Colors.color_20),
            fontFamily:this.getResources().getFontFamily(),
            fontSize: "16px",
            fontWeight:500,
            letterSpacing: "0",
            lineHeight: "18px"
          
        };
    }
}    


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/pagination/paginationcard/paginationcardcss.tsx